var _path, _rect, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 80,
    viewBox: "0 0 71 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14C13.5 8.20101 18.201 3.5 24 3.5C29.799 3.5 34.5 8.20101 34.5 14V23.5H13.5V14Z",
    stroke: "#005FEE",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 19,
    width: 49,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_240_1282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 41.6586C29.3304 40.8349 31 38.6124 31 36C31 32.6863 28.3137 30 25 30C21.6863 30 19 32.6863 19 36C19 38.6124 20.6696 40.8349 23 41.6586V49C23 50.1046 23.8954 51 25 51C26.1046 51 27 50.1046 27 49V41.6586Z",
    fill: "#005FEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_240_1282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 55.5,
    r: 24.5,
    fill: "url(#paint1_linear_240_1282)",
    fillOpacity: 0.8
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 45C45.4562 45 44.4358 45.3241 43.5678 45.9314C42.6999 46.5386 42.0234 47.4017 41.624 48.4115C41.2245 49.4213 41.12 50.5324 41.3236 51.6044C41.5273 52.6764 42.0299 53.6611 42.768 54.434C43.5062 55.2069 44.4466 55.7332 45.4704 55.9464C46.4941 56.1597 47.5553 56.0502 48.5197 55.632C49.4841 55.2137 50.3084 54.5054 50.8883 53.5966C51.4682 52.6878 51.7778 51.6193 51.7778 50.5263C51.7778 49.0606 51.2217 47.655 50.232 46.6186C49.2422 45.5822 47.8998 45 46.5 45ZM46.5 53.8421C45.8737 53.8421 45.2614 53.6476 44.7407 53.2833C44.2199 52.9189 43.8141 52.4011 43.5744 51.7952C43.3347 51.1893 43.272 50.5226 43.3942 49.8794C43.5164 49.2362 43.818 48.6454 44.2608 48.1817C44.7037 47.718 45.2679 47.4022 45.8822 47.2742C46.4965 47.1463 47.1332 47.212 47.7118 47.4629C48.2905 47.7139 48.785 48.1389 49.133 48.6842C49.4809 49.2294 49.6667 49.8705 49.6667 50.5263C49.6667 51.4057 49.333 52.2491 48.7392 52.8709C48.1453 53.4928 47.3399 53.8421 46.5 53.8421ZM56 66V64.8947C56 62.8428 55.2215 60.8749 53.8358 59.424C52.4502 57.973 50.5708 57.1579 48.6111 57.1579H44.3889C42.4292 57.1579 40.5498 57.973 39.1642 59.424C37.7785 60.8749 37 62.8428 37 64.8947V66H39.1111V64.8947C39.1111 63.4291 39.6672 62.0234 40.6569 60.987C41.6467 59.9507 42.9891 59.3684 44.3889 59.3684H48.6111C50.0109 59.3684 51.3533 59.9507 52.3431 60.987C53.3328 62.0234 53.8889 63.4291 53.8889 64.8947V66H56Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_240_1282",
    x: 2,
    y: 11,
    width: 89,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_240_1282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_240_1282",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_240_1282",
    x1: 0,
    y1: 19,
    x2: 0,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0063FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_240_1282",
    x1: 46.5,
    y1: 31,
    x2: 46.5,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0408163,
    stopColor: "#A7DFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3E9FF",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.e4a691ee30cfe8595396ab01e191b309.svg";
export { ForwardRef as ReactComponent };